// ======================================================================
// File Name       : PageTitleConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import * as Path from './PathConstants';

const PAGE_TITLE_CONFIG = {
  [Path.LOGIN]: 'ログイン | 管理ユーザー画面',
  [Path.PASSWORD_RESET_REQUEST]: 'パスワード再設定 | 管理ユーザー | 管理ユーザー画面',
  [Path.SUPERUSER_PASSWORD_RESET_REQUEST]: 'パスワード再設定 | SuperUser | 管理ユーザー画面',
  [Path.PASSWORD_RESET_REQUEST_COMPLETE]: 'パスワード再設定 | 完了 | 管理ユーザー画面',
  [Path.TOP_LIST]: 'トップ | 管理ユーザー画面',
  [Path.SERVICE_LOGIN_LIST]: 'サービス選択 | 管理ユーザー画面',
  [Path.ENTERPRISE_LIST]: '企業情報 | 一覧・編集 | 管理ユーザー画面',
  [Path.SERVICE_LIST]: 'サービス管理 | 一覧 | 管理ユーザー画面',
  [Path.SERVICE_DETAIL]: 'サービス管理 | 詳細 | 管理ユーザー画面',
  [Path.SERVICE_EDIT]: 'サービス管理 | 編集 | 管理ユーザー画面',
  [Path.SERVICE_REGISTER]: 'サービス管理 | 新規登録 | 管理ユーザー画面',
  [Path.SERVICE_IMPORT]: 'サービス管理 | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.SUPERUSER_LIST]: 'SuperUser | 一覧 | 管理ユーザー画面',
  [Path.SUPERUSER_DETAIL]: 'SuperUser | 詳細 | 管理ユーザー画面',
  [Path.SUPERUSER_EDIT]: 'SuperUser | 編集 | 管理ユーザー画面',
  [Path.SUPERUSER_REGISTER]: 'SuperUser | 新規登録 | 管理ユーザー画面',
  [Path.SUPERUSER_IMPORT]: 'SuperUser | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.AUTHORITY_LIST]: 'ロール | 一覧 | 管理ユーザー画面',
  [Path.AUTHORITY_DETAIL]: 'ロール | 詳細 | 管理ユーザー画面',
  [Path.AUTHORITY_EDIT]: 'ロール | 編集 | 管理ユーザー画面',
  [Path.AUTHORITY_REGISTER]: 'ロール | 新規登録 | 管理ユーザー画面',
  [Path.AUTHORITY_IMPORT]: 'ロール | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.SERVICE_RECORD_COMPANY_LIST]: 'システム利用実績 | 企業別 | 管理ユーザー画面',
  [Path.SERVICE_RECORD_SERVICE_LIST]: 'システム利用実績 | サービス別 | 管理ユーザー画面',
  [Path.SERVICE_RECORD_SERVICES_LIST]: 'システム利用実績 | サービス一覧 | 管理ユーザー画面',
  [Path.SERVICE_RECORD_DOWNLOAD_FORM]: 'システム利用実績 | 帳票ダウンロード | 管理ユーザー画面',
  [Path.ENTERPRISE_NOTIFICATION_LIST]: '企業向けお知らせ | 一覧 | 管理ユーザー画面',
  [Path.ENTERPRISE_NOTIFICATION_DETAIL]: '企業向けお知らせ | 詳細 | 管理ユーザー画面',
  [Path.ENTERPRISE_NOTIFICATION_EDIT]: '企業向けお知らせ | 編集 | 管理ユーザー画面',
  [Path.ENTERPRISE_NOTIFICATION_REGISTER]: '企業向けお知らせ | 新規登録 | 管理ユーザー画面',
  [Path.ENTERPRISE_NOTIFICATION_IMPORT]: '企業向けお知らせ | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.SERVICE_NOTIFICATION_LIST]: 'サービス向けお知らせ | 一覧 | 管理ユーザー画面',
  [Path.SERVICE_NOTIFICATION_DETAIL]: 'サービス向けお知らせ | 詳細 | 管理ユーザー画面',
  [Path.SERVICE_NOTIFICATION_EDIT]: 'サービス向けお知らせ | 編集 | 管理ユーザー画面',
  [Path.SERVICE_NOTIFICATION_REGISTER]: 'サービス向けお知らせ | 新規登録 | 管理ユーザー画面',
  [Path.SERVICE_NOTIFICATION_IMPORT]: 'サービス向けお知らせ | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.USERFRONT_LOGIN_SCREEN_UPDATE]: '受講ユーザー｜ログイン画面編集 | 管理ユーザー画面',
  [Path.USERFRONT_TOP_SCREEN_UPDATE]: '受講ユーザー｜トップ画面編集 | 管理ユーザー画面',
  [Path.USER_LIST]: 'ユーザー | 一覧 | 管理ユーザー画面',
  [Path.USER_DETAIL]: 'ユーザー | 詳細 | 管理ユーザー画面',
  [Path.USER_EDIT]: 'ユーザー | 編集 | 管理ユーザー画面',
  [Path.USER_REGISTER]: 'ユーザー | 新規登録 |  管理ユーザー画面',
  [Path.USER_IMPORT]: 'ユーザー | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.GROUP_LIST]: 'ユーザーグループ | 一覧 | 管理ユーザー画面',
  [Path.GROUP_IMPORT]: 'ユーザーグループ | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.USER_HISTORY_STUDENT_LIST]: '学習履歴 | ユーザー別 | 一覧 | 管理ユーザー画面',
  [Path.USER_HISTORY_STUDENT_DETAIL]: '学習履歴 | ユーザー別一覧詳細 | 管理ユーザー画面',
  [Path.USER_HISTORY_STUDENT_RESULT]: '学習履歴 | ユーザー別一覧詳細 | 詳細 | 管理ユーザー画面',
  [Path.USER_HISTORY_COURSE_LIST]: '学習履歴 | コース別 | 一覧 | 管理ユーザー画面',
  [Path.USER_HISTORY_COURSE_DETAIL]: '学習履歴 | コース別一覧詳細 | 管理ユーザー画面',
  [Path.USER_HISTORY_COURSE_STUDENT_DETAIL]: '学習履歴 | コース別一覧詳細 | 詳細 | 管理ユーザー画面',
  [Path.PARTICIPANT_LIST]: 'ライブ実績｜ユーザー別｜一覧 | 管理ユーザー画面',
  [Path.PARTICIPANT_DETAIL]: 'ライブ実績 | ユーザ別参加実績 | 詳細 | 管理ユーザー画面',
  [Path.USER_HISTORY_LIVE_PERFORMANCE_LIST]: 'ライブ実績｜ライブ別｜一覧 | 管理ユーザー画面',
  [Path.USER_HISTORY_LIVE_PERFORMANCE_DETAIL]: 'ライブ実績 | ライブ別参加実績 | 詳細 | 管理ユーザー画面',
  [Path.LEARNING_HISTORY_CSV_DOWNLOAD]: '学習履歴CSVダウンロード | 管理ユーザー画面',
  [Path.PROGRESS_STATUS_CSV_DOWNLOAD]: '進捗状況CSVダウンロード | 管理ユーザー画面',
  [Path.ACCOUNT_EDIT]: 'アカウント | 情報編集 | 管理ユーザー画面',
  [Path.CONTENT_DISTRIBUTION_LIST]: 'コンテンツ配布 | 配布先一覧 | 管理ユーザー画面',
  [Path.CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL]: 'コンテンツ配布 | コンテンツ一覧 | 管理ユーザー画面',
  [Path.CONTENT_DISTRIBUTION_OFFER_LIST_EDIT]: 'コンテンツ配布 | コンテンツ一覧編集 | 管理ユーザー画面',
  [Path.CONTENT_DISTRIBUTION_USAGE_DETAIL]: 'コンテンツ配布 | 利用状況 | 管理ユーザー画面',
  [Path.CONTENT_DISTRIBUTION_REGISTER]: 'コンテンツ配布 | 新規登録 | 管理ユーザー画面',
  [Path.CONTENT_DISTRIBUTION_IMPORT]: 'コンテンツ配布 | CSV投入・一括処理一覧 | コンテンツ | 管理ユーザー画面',
  [Path.COURSE_DISTRIBUTION_IMPORT]: 'コンテンツ配布 | CSV投入・一括処理一覧 | コース | 管理ユーザー画面',
  [Path.COURSE_LIST]: 'コース | 一覧 | 管理ユーザー画面',
  [Path.COURSE_IMPORT]: 'コース | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.COURSE_THUMBNAIL_UPDATE]: 'コース | 初期画像変更 | 管理ユーザー画面',
  [Path.CONTENT_QUESTION_LIST]: '問題 | 一覧 | 管理ユーザー画面',
  [Path.CONTENT_QUESTION_DETAIL]: '問題 | 詳細 | 管理ユーザー画面',
  [Path.CONTENT_QUESTION_EDIT]: '問題 | 編集 | 管理ユーザー画面',
  [Path.CONTENT_QUESTION_REGISTER]: '問題 | 新規登録 | 管理ユーザー画面',
  [Path.CONTENT_QUESTION_IMPORT]: '問題 | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_LIST]: 'ドリル | 一覧 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_DETAIL]: 'ドリル | 詳細 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_EDIT]: 'ドリル | 編集 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_REGISTER]: 'ドリル | 新規登録 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_IMPORT]: 'ドリル | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_SKIN_LIST]: 'スキン | 一覧 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_SKIN_DETAIL]: 'スキン | 詳細 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_SKIN_EDIT]: 'スキン | 編集 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_SKIN_REGISTER]: 'スキン | 新規登録 | 管理ユーザー画面',
  [Path.CONTENT_DRILL_NOTIFICATION_LIST]: '通知メッセージ | 一覧',
  [Path.CONTENT_DRILL_NOTIFICATION_DETAIL]: '通知メッセージ | 詳細',
  [Path.CONTENT_DRILL_NOTIFICATION_EDIT]: '通知メッセージ | 編集',
  [Path.CONTENT_DRILL_NOTIFICATION_REGISTER]: '通知メッセージ | 新規登録',
  [Path.CONTENT_QUESTION_ATTRIBUTE_LIST]: '問題属性 | 管理ユーザー画面',
  [Path.CONTENT_VIDEO_LIST]: 'ビデオ | 一覧 | 管理ユーザー画面',
  [Path.CONTENT_VIDEO_DETAIL]: 'ビデオ | 詳細 | 管理ユーザー画面',
  [Path.CONTENT_VIDEO_EDIT]: 'ビデオ | 編集 | 管理ユーザー画面',
  [Path.CONTENT_VIDEO_REGISTER]: 'ビデオ | 新規登録 | 管理ユーザー画面',
  [Path.CONTENT_VIDEO_IMPORT]: 'ビデオ | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.CONTENT_DOCUMENT_LIST]: 'ドキュメント | 一覧 | 管理ユーザー画面',
  [Path.CONTENT_DOCUMENT_DETAIL]: 'ドキュメント | 詳細 | 管理ユーザー画面',
  [Path.CONTENT_DOCUMENT_EDIT]: 'ドキュメント | 編集 | 管理ユーザー画面',
  [Path.CONTENT_DOCUMENT_REGISTER]: 'ドキュメント | 新規登録 | 管理ユーザー画面',
  [Path.CONTENT_DOCUMENT_IMPORT]: 'ドキュメント | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.CONTENT_LINK_LIST]: 'リンク | 一覧 | 管理ユーザー画面',
  [Path.CONTENT_LINK_DETAIL]: 'リンク | 詳細 | 管理ユーザー画面',
  [Path.CONTENT_LINK_EDIT]: 'リンク | 編集 | 管理ユーザー画面',
  [Path.CONTENT_LINK_REGISTER]: 'リンク | 新規登録  | 管理ユーザー画面',
  [Path.CONTENT_LINK_IMPORT]: 'リンク | CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.SCORING_REPORT_TOP]: 'レポート | 一覧 | 管理ユーザー画面',
  [Path.SCORING_REPORT_GET]: 'レポート | 取得 | 管理ユーザー画面',
  [Path.SCORING_REPORT_CORRECTION]: 'レポート | 添削 | 管理ユーザー画面',
  [Path.SCORING_REPORT_APPROVAL]: 'レポート | 承認 | 管理ユーザー画面',
  [Path.SCORING_REPORT_REMAND]: 'レポート | 差戻し | 管理ユーザー画面',
  [Path.SCORING_REPORT_COLLECTION]: 'レポート | 強制回収 | 管理ユーザー画面',
  [Path.SCORING_UNSUBMITTED_LIST]: '未提出レポート | 一覧 | 管理ユーザー画面',
  [Path.SCORING_ARCHIVEMENT_LIST]: '添削者別実績 | 一覧 | 管理ユーザー画面',
  [Path.SCORING_ARCHIVEMENT_DETAIL]: '添削者別実績 | 詳細 | 管理ユーザー画面',
  [Path.RECEIVED_MESSAGE_LIST]: 'メッセージ | 一覧 | 管理ユーザー画面',
  [Path.RECEIVE_CHAT_DETAIL]: 'メッセージ | 送信 | 管理ユーザー画面',
  [Path.SENT_MESSAGE_LIST]: 'メッセージスレッド | 一覧 | 管理ユーザー画面',
  [Path.SENT_MESSAGE_THREAD_DETAIL]: 'メッセージスレッド | 詳細 | 管理ユーザー画面',
  [Path.SENT_CHAT_DETAIL]: 'メッセージスレッド | 送信 | 管理ユーザー画面',
  [Path.REGISTER_MESSAGE_THREAD]: 'メッセージスレッド | 作成 | 管理ユーザー画面',
  [Path.EMAIL_LIST]: 'メール | 一覧 | 管理ユーザー画面',
  [Path.EMAIL_REGISTER]: 'メール | 新規登録 | 管理ユーザー画面',
  [Path.RESERVED_EMAIL_LIST]: '予約メール | 一覧 | 管理ユーザー画面',
  [Path.RESERVED_EMAIL_DETAIL]: '予約メール | 詳細  | 管理ユーザー画面',
  [Path.RESERVED_EMAIL_EDIT]: '予約メール | 編集 | 管理ユーザー画面',
  [Path.MULTI_LANGUAGE_LIST]: '多言語ドキュメント｜一覧 | 管理ユーザー画面',
  [Path.MULTI_LANGUAGE_EDIT]: '多言語ドキュメント｜編集 | 管理ユーザー画面',
  [Path.MULTI_LANGUAGE_PROCESS_RESULT_LIST]: '多言語翻訳結果｜一覧 | 管理ユーザー画面',
  [Path.MULTI_LANGUAGE_PROCESS_DETAIL]: '多言語翻訳結果｜詳細 | 管理ユーザー画面',
  [Path.CHANGE_PASSWORD]: 'パスワード変更画面',
  [Path.ENTERPRISE_IMPORT]: '企業CSV投入・一括処理一覧 | 管理ユーザー画面',
  [Path.USER_HISTORY_CONTENT_LIST]: '学習履歴 | コンテンツ別 | 管理ユーザー画面',
  [Path.USER_HISTORY_CONTENT_DETAIL]: '学習履歴 | コンテンツ別 | 履歴情報の詳細 | 管理ユーザー画面',
  [Path.SCORING_DISTRIBUTION_REPORT]: '添削管理 | レポート分配 | 管理ユーザー画面',
  [Path.USER_HISTORY_COURSE_STUDENT_RESULT]: '学習履歴 | コース別履歴情報 | ユーザ別履歴情報(ドリル) | 管理ユーザー画面',
  [Path.PREVIEW_EACH_QUESTION_ATTRIBUTE]: 'ドリル | 問題属性の検索 | 管理ユーザー画面',
  [Path.SERVICE_GROUP_LIST]: 'サービスグループ | 一覧 | 管理ユーザー画面',
  [Path.SERVICE_GROUP_DETAIL]: 'サービスグループ | 詳細 | 管理ユーザー画面',
  [Path.SUPERUSER_ENTERPRISE_ROLE_LIST]: 'SuperUser企業ロール | 一覧 | 管理ユーザー画面',
  [Path.SUPERUSER_ENTERPRISE_ROLE_REGISTER]: 'SuperUser企業ロール | 新規登録 | 管理ユーザー画面',
  [Path.SUPERUSER_ENTERPRISE_ROLE_DETAIL]: 'SuperUser企業ロール | 詳細 | 管理ユーザー画面',
  [Path.SUPERUSER_ENTERPRISE_ROLE_EDIT]: 'SuperUser企業ロール | 編集 | 管理ユーザー画面',
  [Path.SUPERUSER_SERVICE_ROLE_LIST]: 'SuperUserサービスロール | 一覧 | 管理ユーザー画面',
  [Path.SUPERUSER_SERVICE_ROLE_REGISTER]: 'SuperUserサービスロール | 新規登録 | 管理ユーザー画面',
  [Path.SUPERUSER_SERVICE_ROLE_DETAIL]: 'SuperUserサービスロール | 詳細 | 管理ユーザー画面',
  [Path.SUPERUSER_SERVICE_ROLE_EDIT]: 'SuperUserサービスロール | 編集 | 管理ユーザー画面',
  [Path.LOGIN_HISTORY_ENTERPRISE_CSV_DOWNLOAD]: 'SuperUserログイン履歴のダウンロード | 管理ユーザー画面',
  [Path.LOGIN_HISTORY_SERVICE_CSV_DOWNLOAD]: 'ログイン履歴ダウンロード | 管理ユーザー画面',
};

export default PAGE_TITLE_CONFIG;
